module.exports = __webpack_public_path__ + "img/oeuf.b78abf6a.svg";